import { cmApi, type SecurityFprintMultipleRow } from '@/api/cmApi'
import { cheaterUsername, idChipList } from './securityUi'
import { SecurityCrudPage } from './SecurityCrudPage'

/** Live fingerprint rows from Player-API device_id_saved audits via CM-API. */
export function FprintMultipleDeviceIdsPage() {
  return (
    <SecurityCrudPage<SecurityFprintMultipleRow>
      title="Fingerprint multiple device IDs"
      subtitle="Players with more than one web fingerprint saved"
      queryKey="fprint-multiple"
      emptyHint="No multi-fingerprint players yet. Requires Player-API fingerprint saveDeviceId logs."
      listFn={cmApi.securityFprintMultipleList}
      columns={[
        {
          key: 'user',
          header: 'Username',
          cell: (r) => cheaterUsername(r.username, r.isCheater),
        },
        { key: 'count', header: 'Count', cell: (r) => r.fprintCount },
        {
          key: 'ids',
          header: 'Fingerprints',
          cell: (r) => idChipList(r.fingerprints),
        },
      ]}
    />
  )
}
